export const KEY = {
  ENTER: {
    code: 13,
    name: 'enter',
  },
  SPACE: {
    code: 32,
    name: 'space',
  },
  DOWN: {
    code: 40,
    name: 'arrowdown',
  },
  UP: {
    code: 38,
    name: 'arrowup',
  },
  ESC: {
    code: 27,
    name: 'esc',
  },
  TAB: {
    code: 9,
    name: 'tab',
  },
  BACKSPACE: {
    code: 8,
    name: 'backspace',
  },
};
export const checkKey = (event, keyCode, keyName) =>
  event.which === keyCode || event.keyCode === keyCode || event.key === keyName;

export const handleChange = setter => value => setter(value);
